import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { FiatWalletService } from "@main-services/wallet/fiat_wallet.service";
import { FiatWallet, FiatWalletAdapter } from "@modules/+new/wallets/domain/entities/fiat-wallet.model";
import { CryptoWalletService } from "@main-services/wallet/crypto_wallet.service";
import {
	CryptoCoinWallet,
	CryptoCoinWalletAdapter
} from "@modules/+new/wallets/domain/entities/cryptocoin-wallet.model";

@Injectable({
	providedIn: "any"
})
export class WalletsBridgeService {
	private fiatWalletAdapter: FiatWalletAdapter = new FiatWalletAdapter();
	private cryptoCoinWalletAdapter: CryptoCoinWalletAdapter = new CryptoCoinWalletAdapter();
	public constructor(
		private readonly fiatWalletService: FiatWalletService,
		private readonly cryptoWalletService: CryptoWalletService
	) {}

	public getFiatWallets$(): Observable<FiatWallet[]> {
		this.fiatWalletService.updateWalletsDefaultFiat();

		return of(this.fiatWalletAdapter.adaptMany(this.fiatWalletService.list));
	}

	public getCryptoWallets$(): Observable<CryptoCoinWallet[]> {
		return of(this.cryptoCoinWalletAdapter.adaptMany(this.cryptoWalletService.list));
	}
}
